import {useSelector} from 'react-redux';
import React, {useState} from 'react';
import {EnrichmentsQuestionScreen} from './EnrichmentsQuestion';
import { useAnswerableEnrichments } from '../../../data/hooks/enrichments/useAnswerableEnrichments';
import {useEvent} from '../../../data/hooks/eventHooks';
import {useI18n} from '../../../data/hooks/i18nHooks';
import EnrichmentConclusionScreen from './EnrichmentConclusionScreen';
import LoadEnrichments from '../../loaders/LoadEnrichments';
import WaitWhileBusy from '../../WaitWhileBusy';

const EventEnrichmentsRequired = props => {
    const {eventId} = props,
        event = useEvent(eventId),
        i18n = useI18n(),
        [skipped, setSkipped] = useState([]),
        enrichments = useAnswerableEnrichments(event.id).filter(nextEnrichment => !nextEnrichment.answer.length && !skipped.includes(nextEnrichment.id)),
        nextEnrichment = enrichments[0],
        returnURL = '/',
        category = useSelector(state => Object.values(state.events[eventId]?.event.enrichment_categories).find(ecat => ecat.category == 1));

    function handleQuestionAnswered() {
        // do nothing?
    }

    function handleQuestionSkipped() {
        setSkipped([...skipped, nextEnrichment.id]);
    }

    if (nextEnrichment) {
        let scrProps = {
            i18n,
            event,
            eventId: event.id,
            returnURL,
            headerColor: event.settings.primary_color,
            nextPage: null, // will control the flow on this side
            headerTitle: category?.label || null,
            question: nextEnrichment,
            onSubmitSuccess: handleQuestionAnswered,
            onSkip: handleQuestionSkipped,
        };
        return <EnrichmentsQuestionScreen {...scrProps} key={nextEnrichment.id} />;
    } else {
        return <EnrichmentConclusionScreen {...props} cat={category?.category} />;
    }
};

export default props => (
    <LoadEnrichments force {...props}>
        <WaitWhileBusy>
            <EventEnrichmentsRequired {...props} />
        </WaitWhileBusy>
    </LoadEnrichments>
);
